import { TAG_API } from "shared/constants/api-endpoint";
import { apiClient } from "shared/plugins/http-service";
import { RemovedTagModel, TagModel } from "./tag.models";

export const getTagList = async (langCode?: string) => {
  const createResponse = await apiClient.getHttp<TagModel[]>(`${TAG_API}`, {
    params: { langCode },
  });
  return createResponse;
};

export const removeTag = async (removedModel: RemovedTagModel) => {
  const response = await apiClient.postHttp(
    `${TAG_API}/remove_list`,
    removedModel
  );
  return response;
};

export const getTagByIdApi = async (id: number, langCode?: string) => {
  return await apiClient.getHttp<TagModel>(`${TAG_API}/${id}`, {
    params: { langCode },
  });
};

export const addTag = async (model: TagModel, langCode?: string) => {
  const response = await apiClient.postHttp<number>(`${TAG_API}`, model, {
    params: { langCode },
  });
  return response;
};

export const updateTag = async (model: TagModel, langCode?: string) => {
  const response = await apiClient.putHttp<number>(`${TAG_API}`, model, {
    params: { langCode },
  });
  return response;
};
